import { RequestsGuard } from './requests.guard';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/material.module';
import { RequestsRoutingModule } from './requests-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { PanelModule } from './panel/panel.module';
import { CanDeactivateGuard } from '@app/@core/guards/can-deactivate.guard';

@NgModule({
  declarations: [],
  imports: [CommonModule, RequestsRoutingModule, MaterialModule, TranslateModule],
  exports: [PanelModule],
  providers: [DatePipe, RequestsGuard, CanDeactivateGuard],
})
export class RequestsModule {}
